// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ViewUI from "view-design";
import "babel-polyfill";
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
/*import 'vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css'*/
import { isEmpty } from "@/utils";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// 引入药尊宝弹窗样式
import "@/assets/css/yzuenbao-dialog.css";
Vue.use(ElementUI);
import { Message } from "element-ui";
import scroll from 'vue-seamless-scroll'
import { behaviorpageAccess, behaviorUserPageAccess } from '@/api/apiPot.js'
Vue.use(scroll)

// import style
import "view-design/dist/styles/iview.css";
//引入全局css
import "./assets/css/common.css";
import store from "@/vuex/store";
import "@/styles/index.less"; // 全局样式

//引入axios请求数据
import axios from "axios";
import http from "./utils/http";
import https from "./utils/http";
import Qs from "qs";
// main.js
import noLogin from "./components/popup";
// 全局未登录
Vue.prototype.$noLogin = noLogin.install;

/*import http from '@/request'; // 引入接口列表*/

Vue.use(ViewUI);

Vue.prototype.axios = axios;
Vue.prototype.$http = http;
Vue.prototype.$https = https;
Vue.prototype.qs = Qs;
/*Vue.prototype.$http = http; // 将接口列表挂载到全局*/
var startTime = '';
var endData = '';
Vue.config.productionTip = false;
router.beforeEach((to, from, next) => {
  /*
    开始时间是开始记录
    结束 - 只用来发请求 -》 清空
  */

  if (startTime) {
    endData = new Date().getTime()
    var count = endData - startTime
    console.log('to.meta.nameCN:', to.meta.nameCN);
    if (count < 0) {
      count = 1000
    } else if (count > 3600000) {
      count = 3600000
    }
    behaviorpageAccess({ page_index: to.meta.nameCN || '首页', superior_index: from.meta.nameCN || '', residence_time: count })
    // 发请求 -》 -
    setTimeout(() => {
      behaviorUserPageAccess({ page_index: to.meta.nameCN || '首页', residence_time: count })
    }, 300)
  }
  startTime = new Date().getTime()


  // if (!status) {
  //   console.log('开始时间');
  //   startTime = new Date().getTime()
  //   status = true
  // } else {
  //   endData = new Date().getTime()


  //   status = false
  // }



  if (to.path === "/GoodsDetailPreview") {
    console.log("不拦截-----------------");
    // 如果不需要权限校验，直接进入路由界面
    ViewUI.LoadingBar.start();
    next();
  } else {
    if (!to.meta.isAllowNoLogin) {

      // 判断该路由是否需要登录权限
      if (to.path === "/Helps/HelpLogin") {
        ViewUI.LoadingBar.start();
        next();
        return
      }
      if (isEmpty(window.sessionStorage.getItem("userName"))) {
        // 获取当前的token是否存在
        console.log("没登录");
        noLogin.install();
        // this.$noLogin();
        /* if(to.path === "/GoodsDetailPreview"){
           console.log("不拦截商品详情预览页");
           // 商品详情预览页 不需要权限校验，直接进入路由界面
           ViewUI.LoadingBar.start();
         }else {
           noLogin.install();
           // this.$noLogin();
         }*/

      } else {
        if (!isEmpty(window.sessionStorage.getItem("userInfo"))) {
          // 拦截/NewSpecialOffer）和新人优惠券（NewCoupons）页面
          if (
            (to.path === "/NewSpecialOffer" || to.path === "/NewCoupons") &&
            (sessionStorage.getItem('new_customer') != 1)
          ) {
            Message.error("你不是新用户，暂不可享受新人福利");
          }
          else {
            console.log("正常登录----");
            // 获取来源页面和去往的页面
            ViewUI.LoadingBar.start();
            next();
            // 创建一个时间戳，用于记录页面访问时长


            // 在路由元信息（meta）中存储这些信息，以便后续使用
            // to.meta.startTime = startTime;


          }
        }
      }
    } else {
      console.log("不拦截");
      // 如果不需要权限校验，直接进入路由界面
      ViewUI.LoadingBar.start();
      next();
    }
  }

});

router.afterEach(to => {
  ViewUI.LoadingBar.finish();
});

/* eslint-disable no-new */
window.vm = new Vue({
  el: "#app",
  store,
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js